import { useIsDevOrSuperUser } from "@repo/api";

import { useSettings } from "../settings/SettingsProvider";

export const useSearchAccess = (context: "PROJECT" | "CALENDAR") => {
  const { feature_flags } = useSettings();
  const isDevOrSuperUser = useIsDevOrSuperUser();

  const shouldShowSearchCoworker = () => {
    if (context === "PROJECT" && feature_flags?.restrict_search_by_coworker) {
      return false;
    }

    if (context === "CALENDAR") {
      return feature_flags?.restrict_search_by_coworker
        ? isDevOrSuperUser
        : true;
    }

    return true;
  };

  return {
    shouldShowSearchCoworker: shouldShowSearchCoworker(),
  };
};
